<template>
    <div>
        <div class="align-center">
            <slot name="content"></slot>
        </div>
        <div class="align-center">
            <form>
                <div class="space-bottom-1" v-for="step in steps" :key="step">
                    
                    <component
                        @addField="addField"
                        @clearFields="clearFields"
                        class="component-style"
                        :is="step.type === 'text' ? 'TextField': step.type"
                        :isAnonymous='isAnonymousCustomer'
                        :step="step"
                        :showButton="false"
                        :inputStyling="inputStyling"
                        :productPrices="productPrices"
                        v-model="emittedFields[step.name]"
                    />
                    
                </div>
                
                <input class="field-style" name="name" value="" />
                <ButtonSection
                    v-if="showButton"
                    :inputValid="inputValid"
                    :order="order"
                    :buttonText="buttonText"
                    :exitButtonText="exitButtonText"
                    @hide-modal="$emit('hide-modal')"
                    @progress="progress"
                />
            </form>
        </div>
 
    </div>

    </template>

<script>
    import Vue from 'vue';
    import { mapGetters, mapActions } from 'vuex';
    import Modal from '../../utils/modal';
    import vButton from '../../utils/button';
    import ErrorStateIcon from '../../utils/error-state-icon';
    import dropdown from "./Dropdown.vue";
    import dropdowncheckbox from "./DropdownCheckbox.vue"
    import firstnameLastname from "./FirstnameLastname.vue";
    import phone from "./Phone.vue";
    import email from "./Email.vue"
    import ButtonSection from "./ButtonSection.vue";
    import TextField from './TextField.vue';
    import AdjustQuantities from '../checkout/adjust-cart-quantities.vue'
    
    export default {

        components: { Modal, vButton, ErrorStateIcon, dropdown, firstnameLastname, phone, email, ButtonSection, TextField, dropdowncheckbox, AdjustQuantities},

        props: {
            steps: {
                type: Object,
                required: true
            },
            showButton: {
                type: Boolean,
                required: false
            },
            fieldsToMonitor:{
                type: Array,
                required: true
            },
            buttonText:{
                type: String,
                required: true
            },
            exitButtonText:{
                type: String,
                required: false,
                default: null
            },
            buttonStyling: {
                type: String, 
                required: false
            },
            productPrices: {
                type: Object, 
                required: false
            }
            
        },

        data() {
            return {
                windowWidth: window.innerWidth,
                emittedFields: {},
                confirmation: false,
                inputStyling: 'component-input-styling', 
                recaptchaToken: ''
            }
        },

        computed: {
            ...mapGetters('webstoreForm' , [
                'webstoreForm'
            ]),
            ...mapGetters([
                'isAnonymousCustomer',
            ]),

            ...mapGetters('content', [
                'webstoreContent',
                'checkoutContent',
                'checkoutSharedContent'
            ]),

            inputValid(){
                if(!this.fieldsToMonitor){
                    return true;
                }
                for(let i = 0; i < this.fieldsToMonitor.length; ++i){
                    if(!this.emittedFields[this.fieldsToMonitor[i]]?.valid){
                        return false;
                    }

                }
                return true;
            }
            
        },

        methods: {
            ...mapActions('content', ['getCheckoutContent']),
            hideModal() {
                this.$emit('hide-modal')
            },

            onResize() {
                this.windowWidth = window.innerWidth;
            },
            progress(){
                this.$emit('progress')
                if(this.inputValid){
                    Object.keys(this.emittedFields).forEach((key) =>{
                        this.emittedFields[key] = this.emittedFields[key]['value']
                
                    })
                    /*validating honeypot field */
                    this.emittedFields['samsaraShipValue'] = document.getElementsByClassName('field-style')[0].value
                    this.$emit('submitHandler', this.emittedFields)
                }
            },
            addField(name, value){
                this.emittedFields[name] = value;
            }, 
            clearFields(){
                this.fieldsToMonitor = []
            }
        },

        mounted() {
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            })
        },

        created(){
            this.fieldsToMonitor.forEach((element) => Vue.set(this.emittedFields, element, {'value': '', valid: false}))
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        }

    }
</script>

<style scoped>
    .inquire-wrapper {
        width: 100%;
    }

    .inquire-wrapper hr {
        width: 150%;
        margin-left: -30%;
    }

    .inputs-wrapper {
        padding: 20px;
        padding-bottom: 0px;
        padding-right: 10px;
        width: 100%;
    }

    .inputs-wrapper input {
        padding: 5px 10px;
    }

    .confirmation {
        padding: 30px;
        padding-bottom: 0px;
        padding-right: 10px;
        padding-top: 10px;
        width: 100%;
    }

    .confirmation p {
        font-weight: 400;
        font-size: 16px;
        line-height: 140%;
        color: #00263E;
    }

    .input-wrapper {
        margin-bottom: 20px;
        font-size: 16px;
    }

    .input-wrapper label {
        font-size: 16px;
        font-weight: 500;
    }

    .input-wrapper textarea {
        width: 100%;
        border: 1px solid #B2BFC7;
        border-radius: 4px;
        height: 100px;
        padding: .5rem;
    }

    .inquire-wrapper ::v-deep .rounded-full { 
        border-radius: 30px;
        padding: 5px 30px;
        max-width: 130px !important;
    }

    .modal-wrapper ::v-deep .close {
        width: 18px !important;
        height: 18px !important;
        top: 3px;
        left: 90%;
    }

    @media (max-width: 736px) {
        .modal-wrapper ::v-deep .cover {
            top: 75px !important;
        }
    }

    .modal-wrapper ::v-deep .close:before {
        height: 18px !important;
    }

    .modal-wrapper ::v-deep .close:after {
        height: 18px !important;
    }

    #modal-title {
        font-size: 24px;
        padding: 3px 30px;
        padding-bottom: 10px;
        text-align: left;
    }

    .component-style ::v-deep .input-styling {
        border: 2px solid #0384FB; 
        box-sizing: border-box; 
        padding: 10px; 
        border-radius: 5px; 
        width: 100%;
    }

    .component-style ::v-deep .input-styling::placeholder {
        color: #C1C9D1;
    }
    .component-style ::v-deep .input-styling:-ms-input-placeholder {
        color: #C1C9D1;
    }
    .component-style ::v-deep .input-styling::-ms-input-placeholder {
        color: #C1C9D1;
    }
    
    .component-style ::placeholder{
        color: #00263E;
    }

    .component-style ::v-deep .error-text-styling{
        color: red;
        position: absolute;
        left: 50%;
        transform: translate(-50%);

    }

    .component-style ::v-deep .multiselect__tags{
        border: 2px solid #0384FB;
    }
    .field-style{
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;
        height: 0;
        width: 0;
        z-index: -1;
    }

    :deep(input[type="text"]){
        margin: 0 !important;
    }

</style>
